import React from 'react';
import InfoSection from '../../components/shared/InfoSection';
import HoverPhoneIcon from '../../images/icon-hover-phone.svg';
import LightbulbIcon from '../../images/icon-lightbulb.svg';
import HouseMeasureIcon from '../../images/icon-house-measure.svg';
import ThreeDHouseIcon from '../../images/icon-house-3d.svg';

const INFO_ITEMS = [
  {
    image: (
      <HoverPhoneIcon
        alt="Icon house phone"
        style={{ display: 'block', margin: 'auto' }}
      />
    ),
    title: 'Snap a Few Photos',
    description:
      'Use our mobile app to take 8 photos capturing each angle of the home. We’ll automatically upload them to the cloud and take it from there.',
  },
  {
    image: (
      <LightbulbIcon
        alt="Icon lightbulb"
        style={{ display: 'block', margin: 'auto' }}
      />
    ),
    title: 'Transform Your Photos',
    description:
      'Using our patented technology, we transform your photos into a fully measured and customizable 3D model. We’ll let you know when it’s ready.',
  },
  {
    image: (
      <HouseMeasureIcon
        alt="Icon House with measuring tape"
        style={{ display: 'block', margin: 'auto' }}
      />
    ),

    title: 'Review Measurements',
    description:
      'Access all roof and siding measurements within the 3D model in our app or online. Or export via PDF, Excel, or other file formats.',
  },
  {
    image: (
      <ThreeDHouseIcon
        alt="Icon House three globes"
        style={{ display: 'block', margin: 'auto' }}
      />
    ),

    title: 'Design in 3D',
    description:
      'Change the roof, siding, and windows using real materials from brands like GAF, JamesHardie, and Alside. See the finished project with our fully shareable 3D model.',
  },
];

const ProductInfoSection = () => (
  <InfoSection
    sectionTitle="How It Works"
    infoItems={INFO_ITEMS}
    numColumns={2}
  />
);

export default ProductInfoSection;
